import { Chip } from "@mui/material";
import { TagRounded } from "@mui/icons-material";

const TagChip = ({ label, color, styles = {}, ...props }) => {
  return (
    <Chip
      label={label}
      icon={<TagRounded color="white" />}
      style={{
        color: "white",
        backgroundColor: color,
        ...styles,
      }}
      {...props}
    />
  );
};

export default TagChip;
